'use client';

import { LayoutGrid, TypographyRhythm } from '@jouzen/ecom-components';

import IpBrandFeatures from './_components/IpBrandFeatures';
import IpIntro from './_components/IpIntro';
import IpPatents from './_components/IpPatents';
import IpTrademarks from './_components/IpTrademarks';
import LegalDisclaimer from './_components/LegalDisclaimer';

const Content = (): JSX.Element => {
  return (
    <LayoutGrid data-cy="page-intellectual-property-notice-grid">
      <TypographyRhythm className="col-main">
        <IpIntro />
        <IpPatents />
        <IpTrademarks />
        <IpBrandFeatures />
        <LegalDisclaimer />
      </TypographyRhythm>
    </LayoutGrid>
  );
};

export default Content;
